/* oxlint-disable no-nested-ternary */
import type { DocNode } from '@atlaskit/adf-schema/doc';
import type { AnalyticsAttributes } from '@atlassian/analytics-bridge/types';
import type { ProformaForm } from '@atlassian/proforma-form-renderer/proforma-form';

// Copied from `platform/packages/proforma/proforma-common-core/src/form-system/components/RenderForm.tsx` to reduce dependencies on `proforma-common-core`
export const isSummaryOnTopLevel = (
	linkedSummaryQuestionId: number,
	docNodes?: DocNode[],
): boolean =>
	docNodes?.some((node) =>
		node.content.some(
			(contentItem) =>
				contentItem.type === 'extension' &&
				// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
				(contentItem.attrs?.parameters as any)?.id === linkedSummaryQuestionId,
		),
	) ?? false;

export function buildFormViewedAnalyticsAttributes(
	proformaForm: ProformaForm,
	locale: string,
): AnalyticsAttributes {
	const { design } = proformaForm;
	const { settings, layout, questions } = design;
	const { translatedLocale, primaryLocale, language } = settings;
	const formId = proformaForm.id;

	const linkedSummaryQuestionId = Object.entries(questions).find(
		([_, question]) => question.jiraField === 'summary',
	);
	const hasLinkedSummary = Boolean(linkedSummaryQuestionId);

	const summaryOnTopLevel = linkedSummaryQuestionId
		? isSummaryOnTopLevel(Number(linkedSummaryQuestionId[0]), layout)
		: false;

	const displayLocale =
		translatedLocale != null
			? translatedLocale
			: primaryLocale != null
				? primaryLocale
				: language != null
					? language
					: locale;

	const translationDetails: AnalyticsAttributes = {
		primaryLocale,
		translatedLocale,
		legacyLanguage: language != null ? language.replace('_', '-') : undefined,
		localeMatched: displayLocale === locale,
		translated: translatedLocale !== primaryLocale,
		translationsApplied: translatedLocale !== undefined,
		userLocale: locale,
	};

	return { hasLinkedSummary, summaryOnTopLevel, translationDetails, formId };
}
